import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from "@angular/core";

import { Subject } from "rxjs";

import { debounceTime, distinctUntilChanged, map } from 'rxjs/operators';


 

@Component({

  selector: 'app-map',

  templateUrl: './map.component.html',

  styleUrls: ['./map.component.scss']

})

 

export class MapComponent implements OnInit, OnChanges {

  status: boolean = false;

  constructor(


  ) {}

 

  @Input() mapStateData:any = [];

  @Input() mapDistrictData:any = [];

  @Input() mapData:any = [];

  @Output() stateClick:any = new EventEmitter();

  selectedState:any = {};

 

  ngOnInit() {
    console.log('mapDistrictDatamapDistrictData',this.mapDistrictData);

 

  }

 

  ngOnChanges(changes: SimpleChanges){

    console.log("mapcompo", changes)

 

  }

 

  getDistrictData(event:any){
    
    this.selectedState = event;

    this.stateClick.emit(event);

  }

}